import { render, staticRenderFns } from "./Spotify.vue?vue&type=template&id=3e375638&scoped=true"
import script from "./Spotify.vue?vue&type=script&lang=js"
export * from "./Spotify.vue?vue&type=script&lang=js"
import style0 from "./Spotify.vue?vue&type=style&index=0&id=3e375638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e375638",
  null
  
)

export default component.exports